import { deriveMaterial } from 'Pods/ThreeDStudio/Shared/Utils/deriveMaterial'
import { getAssetByTypeAndSource } from 'Pods/ThreeDStudio/Shared/Utils/getAssetByTypeAndSource'
import { ACTION, PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

import { getModelFormatOutput } from './getModelFormatOutput'
import { normalizeRunAttributes } from './normalizeRunAttributes'
import { parseImageInput } from './parseImageInput'

/**
 * Builds the ThreeDStudio store patch for a Meshy image-to-3d-pro run.
 * Pulls the input image from inputAssets, derives material from
 * enablePbr/geometryOnly, and opens the model settings panel.
 *
 * @param {Object} openedModel - Run object from the library
 * @returns {Object} parsedData - ThreeDStudio store patch
 */
export const parseMeshyImageTo3dProData = (openedModel) => {
  const {
    id: sessionId,
    generatorSessionId,
    modelFormatOutput: rawModelFormatOutput,
    enablePbr,
    geometryOnly,
    outputAssets,
    private: isPrivate,
    useCase,
  } = openedModel
  const {
    targetPolycount,
    topology: polygonType,
    generateType,
    ultraMode,
    geometryResolution,
  } = normalizeRunAttributes(openedModel.providerRunAttributes)
  const material = deriveMaterial(enablePbr, geometryOnly)
  const {
    assetId: inputThreeD,
    fileUrl: inputThreeDUrl,
  } = getAssetByTypeAndSource(outputAssets, '3d_model', 'ai_generated')
  const modelFormatOutput = getModelFormatOutput({
    modelFormatOutput: rawModelFormatOutput,
    modelUrl: inputThreeDUrl,
  })
  const generationProvider = PROVIDER.MESHY
  const generationAction = ACTION.IMAGE_TO_3D
  const isSmartLowPoly = generateType === 'LowPoly'

  const schema = { generationAction, generationProvider }
  const generation = { sessionId, generatorSessionId }
  const modelSettings = {
    material,
    targetPolycount,
    ...(isSmartLowPoly ? {} : { polygonType }),
    ...parseImageInput(openedModel),
    isPrivate,
    isSmartLowPoly,
    // Runs created before geometry_resolution only carry the legacy ultra_mode flag.
    extraQuality: !!ultraMode || (geometryResolution != null && geometryResolution !== 'standard'),
    selectedUseCase: useCase,
  }
  const viewer = { fileFormat: modelFormatOutput, inputThreeD, material }
  const ui = {
    isModelSettingsOpen: true,
    isViewerSidebarOpen: false,
    activeViewerSidebarTab: undefined,
  }

  return {
    openedModel,
    schema,
    modelSettings,
    viewer,
    ui,
    generation,
  }
}
